import config from '../config';
import { Tenant } from './model/tenant';

export function getTranslatedAdtif(tenant: Tenant, batchId: string, adtif: string, culture: string): string {
  const endpoint = `/api/v2/accounts/${tenant.accountId}/content-area/${tenant.areaId}/Translations/${batchId}/cultures/${culture}:translate?adtifUrl=${adtif}`;
  return `${config.localizationUIServerUrl}${endpoint}`;
}
